import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-created',
  templateUrl: './created.component.html',
  styleUrls: ['./created.component.css']
})
export class CreatedComponent {
  @Input() title!: string;
  @Input() deadline!: Date;
}
